<template>
    <modal
        v-if="show"
        :form="form"
        size="is-small"
        type="is-primary"
        title="Upgrade Account"
        class="has-selectize"
        submit-text="Upgrade Account"
        success-text="Account Upgraded"
        @submit="upgrade"
        @closed="$emit('closed')"
    >
        <div class="content">
            <div v-if="form.errors.has('form')" class="message is-warning">
                <div class="message-body">
                    {{ form.errors.get('form').join(', ') }}
                </div>
            </div>
            <p>
                Upgrade your account by adding funds and receive the first month,
                <strong class="has-text-success">
                    a {{ $filters.currency(subscription.plan.price, 0) }} value
                </strong>
                absolutely FREE!
            </p>

            <form-dropdown
                id="dropdown-amount"
                v-model="form.amount"
                label="Select amount to add"
                placeholder="Select Amount"
                :error="form.errors.get('amount')"
                :settings="{
                    maxItems: 1,
                }"
            >
                <option value="2500">$25</option>
                <option value="5000">$50</option>
                <option value="7500">$75</option>
                <option value="10000">$100</option>
            </form-dropdown>

            <div class="message is-success" style="margin-top: 2rem">
                <div class="message-body">
                    <div class="media" style="align-items: center">
                        <div class="media-content">
                            <div class="content">
                                <p>
                                    <strong>Enable Auto Recharge</strong><br />
                                    Automatically add <strong>$25</strong> to your account balance
                                    when your balance goes below <strong>$10</strong>.
                                </p>
                            </div>
                        </div>
                        <div class="media-right">
                            <toggle-button
                                v-model="form.auto_recharge"
                                sync
                                :width="50"
                                css-colors
                                :labels="{
                                    checked: 'On',
                                    unchecked: 'Off',
                                }"
                                @change="form.auto_recharge = !form.auto_recharge"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import Form from 'core/Form';

export default {
    emits: ['closed'],
    
    props: {
        show: { type: Boolean, required: true },
    },

    data: () => ({
        form: new Form(
            {
                amount: 0,
                auto_recharge: false,
            },
            false
        ),
    }),

    computed: {
        ...mapState(stores.Subscriptions, ['subscription']),
        ...mapState(stores.Organization, ['organization']),
    },

    methods: {
        async upgradeOrganization() {
            try {
                await this.$store.dispatch('upgradeBillingUpgrade', this.form);
            } catch (errors) {
                if (errors.response.data.card_error) {
                    this.form.errors.record({ form: [errors.response.data.card_error] });
                } else if (errors.response.status !== 422) {
                    this.form.errors.record({ form: ['Something went wrong, please try again.'] });
                }
            }
        },
    },
};
</script>
